module.exports = __webpack_public_path__ + "static/media/hot_2.0fc76e43.png";